<div class="task-wrapper">
  <div class="task-name-icon">
    @if (isApproval()) {
    <mat-icon class="task-icon task-approve-icon">{{isApproval()}}</mat-icon>
    } @else {
    <mat-icon class="task-icon">edit</mat-icon>
    }
    <div class="task-name">{{task.name}}</div>
  </div>

  <div class="task-owner">
    @if (task?.owner) {
    <framework-person-image [person]="$safeNavigationMigration(task?.owner)" size="1.5rem"> </framework-person-image>
    }

    <div class="profile-name">{{task?.owner?.displayName}}</div>
  </div>
  <div class="task-due-edit">
    <div class="task-due-date">{{(task?.dueDate || task?.phaseEnd) | date:'d MMM, y' }}</div>
    @if (hasAction("ChangeDates")) {
    <button styles-icon-button class="edit-button" (click)="openAction('ChangeDates')">
      <mat-icon>{{'ChangeDates' | actionIcon}}</mat-icon>
    </button>
    }
  </div>

  <framework-work-status-chip
    class="task-status"
    [workStatus]="$safeNavigationMigration(task?.status)"
  ></framework-work-status-chip>

  @if (task?.defaultAction || task.actions.length > 0) {
  <div class="actions">
    @if (task?.defaultAction && (task?.status?.id === 'BeingWorkedOn' || task?.status?.id === 'ReadyToWorkOn')) {
    <button
      styles-icon-button
      class="action-button"
      (click)="openAction($safeNavigationMigration(task?.defaultAction?.actionEnum?.id))"
    >
      <mat-icon>{{$safeNavigationMigration(task?.defaultAction?.actionEnum?.id) | actionIcon}}</mat-icon>
    </button>
    } @if (task.actions.length > 0) {
    <framework-action-dropdown
      [actions]="task.actions"
      [location]="location"
      [task]="task"
      [phase]="phase"
      [project]="task | projectPipe"
    ></framework-action-dropdown>
    }
  </div>
  }
</div>
